//Actions
import * as actions from './tpwdActions';

const initialState = {
  selected: '',
  additionalIdCardSelected: false,
  additionalIdCardQuantity: 0,
  selectedCatalogItemTypes: [],
  stepsConfig: {},
  stepsInitialConfig: [],
};

const tpwdReducers = {
  [actions.TPWD_TPWDAS_CLEAR_DATA]: () => initialState,
  [actions.TPWD_MANAGE_ASSET]: (state, { payload }) => {
    return { ...state, ...{ selected: payload } };
  },
  [actions.TPWD_ADDITIONAL_ID_CARD_SELECTED]: (state, { payload }) => {
    return { ...state, ...{ additionalIdCardSelected: payload } };
  },
  [actions.TPWD_ADDITIONAL_ID_CARD_QUANTITY]: (state, { payload }) => {
    return { ...state, ...{ additionalIdCardQuantity: payload } };
  },
  [actions.TPWD_SELECTED_CATALOG_ITEMS]: (state, { payload }) => {
    return { ...state, ...{ selectedCatalogItemTypes: payload } };
  },
  [actions.TPWD_UPDATE_FEE_DETAILS]: (state, { payload }) => {
    return {
      ...state,
      ...{
        updatedFeeDetails: payload,
      },
    };
  },
  [actions.STEPS_CONFIG]: (state, { payload }) => {
    return { ...state, ...{ stepsConfig: payload } };
  },
  [actions.STEPS_CONFIG_UPDATE]: (state, { id }) => {
    const updatedConfig = Array.from(state.stepsConfig);
    const config = updatedConfig[id];
    config.active = 'N';
    updatedConfig[id] = config;
    return {
      ...state,
      ...{
        stepsConfig: updatedConfig,
        stepsInitialConfig: state.stepsInitialConfig,
      },
    };
  },
  [actions.STEPS_CONFIG_ACTIVATE]: (state, { id }) => {
    const updatedConfig = Array.from(state.stepsConfig);
    const config = updatedConfig[id];
    config.active = 'Y';
    updatedConfig[id] = config;
    return {
      ...state,
      ...{
        stepsConfig: updatedConfig,
        stepsInitialConfig: state.stepsInitialConfig,
      },
    };
  },
  [actions.TPWD_UPDATE_PAYMENT_WAS_MADE]: (state, { status }) => {
    return { ...state, ...{ paymentWasMade: status } };
  },
};

export default {
  name: 'tpwd',
  reducers: tpwdReducers,
};
